export interface IGameResult {
  id: number;
  away: string;
  gameNumber: number;
  home: string;
  league: string;
  result: string;
  tendency: string;
}

export interface IGameResultsCollection {
  gameResultsCollection: IGameResult[];
  fromDate: number;
  untilDate: number;
  id: number;
}

export interface IOddsData {
  responseData?: IGameResultsCollection;
  selectedDay?: string;
  selectedWeek?: { key: number; number: number; period: any };
  selectedYear?: number;
  publishDate: number | null;
}

export interface IPairingsProps {
  game: string | number;
}

export const getPairingRows = (
  results: IGameResultsCollection | undefined,
  pairings: IGameResultsCollection | undefined,
  modus: string
) => {
  if (results === undefined || pairings === undefined) {
    return [];
  }
  const data: IGameResult[] =
    modus === 'results'
      ? results.gameResultsCollection
      : pairings.gameResultsCollection;
  const rows = data.map((dataRow: IGameResult) => {
    // E || F ?
    const matches = dataRow.result?.match(/^([0-9:]*)([A-Z]{1})$/);
    return [
      '',
      dataRow.gameNumber,
      `${dataRow.home} : ${dataRow.away}`,
      dataRow.result
        ? matches
          ? `(${matches[2]}) ${matches[1]}`
          : dataRow.result
        : dataRow.tendency,
    ];
  });

  rows.unshift([
    'leer',
    'Spiel',
    'Heim : Gast',
    modus === 'pairings' ? 'Tendenz' : 'Ergebnis',
  ]);
  return rows.map((row) => [...row, `${row[row.length - 1]}`]);
};
